import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import NavMenu from './NavMenu';
import Footer from './footer/Footer';
import ScrollToTop from './ScrollToTop';
import BackAltered from './backaltered/BackAltered';

import { resources } from '../../i18n/i18n';

const Layout = (): React.JSX.Element => { 

    const {t, i18n} = useTranslation();

    React.useEffect(()=>{
        let lang = "en";
        lang = localStorage.getItem("lang") === undefined ? navigator.language : localStorage.getItem("lang")!;
        if (!Object.keys(resources).includes(lang))
            lang = "en";
        i18n.changeLanguage(lang);
        localStorage.setItem("lang", i18n.language);
    }, []);

    return (
        <div className="b-alt">
            <BackAltered />
            <ScrollToTop />
            <NavMenu />
            <Outlet />
            <Footer />
        </div>
    );
};

export default Layout;
